const camelToDash = str => str.replace(/([A-Z])/g, val => `-${val.toLowerCase()}`);

export default camelToDash;
